import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/medal.tsx
var Medal = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M8.17747 14.7017V20.6092C8.17747 21.1036 8.69186 21.4301 9.13926 21.2195L11.7127 20.0085C11.8947 19.9229 12.1053 19.9229 12.2872 20.0085L14.8607 21.2195C15.3081 21.4301 15.8224 21.1036 15.8224 20.6092V14.7017M18.5207 9.30526C18.5207 12.9066 15.6013 15.826 12 15.826C8.39867 15.826 5.47925 12.9066 5.47925 9.30526C5.47925 5.70397 8.39867 2.78455 12 2.78455C15.6013 2.78455 18.5207 5.70397 18.5207 9.30526Z",
		stroke: "currentColor",
		strokeWidth: "1.34911",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.9999 2.78497C8.2963 2.78497 5.29395 5.78733 5.29395 9.49092C5.29395 11.6086 6.27559 13.4971 7.80867 14.7261V20.0261C7.80867 20.9478 8.76748 21.5562 9.60142 21.1638L11.9999 20.0351L14.3984 21.1638C15.2323 21.5562 16.1911 20.9478 16.1911 20.0261V14.7261C17.7242 13.4971 18.7058 11.6086 18.7058 9.49092C18.7058 5.78733 15.7035 2.78497 11.9999 2.78497ZM9.06604 15.5227C9.95223 15.9546 10.9478 16.1969 11.9999 16.1969C13.052 16.1969 14.0476 15.9546 14.9337 15.5227L14.9337 20.0261L12.5353 18.8974C12.1962 18.7378 11.8036 18.7378 11.4645 18.8974L9.06604 20.0261V15.5227Z",
		fill: "currentColor"
	})
});
//#endregion
export { Medal };
